import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import '@/styles/index.scss'

import { createApp } from 'vue'
import App from './App.vue'
import router from '@/routers'
import PageChrome from '@/components/PageChrome.vue'

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
app.use(router)
app.component('PageChrome', PageChrome)
app.use(ElementPlus, { locale: zhCn, size: 'default', zIndex: 3000 })
app.mount('#app')
